function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useContext, memo } from 'react';
import { IntlProvider } from 'react-intl';
import { ThemeProvider } from 'styled-components';
import { useCookie } from '@cb/cookie-manager';
import '@cbhq/cds-fonts/fonts.css';
import getTheme from '../../utils/getTheme.js';
import '../../utils/useIsMobile/index.js';
import DefaultIsMobileContext from '../../utils/useIsMobile/DefaultIsMobileContext.js';
import './constants/index.js';
import { MAIN_LINKS_UK, MAIN_LINKS } from './constants/navLinks.js';
import GlobalNavContext, { DEFAULT_GLOBAL_NAV_CONTEXT } from './context/GlobalNavContext.js';
import UrlContext, { DEFAULT_BASE_URL, COINBASE_ACCOUNTS_DEFAULT_BASE_URL } from './context/UrlContext.js';
import './MainNav/index.js';
import './MobileNav/index.js';
import { jsx, Fragment } from 'react/jsx-runtime';
import { COUNTRY_BANNER_COOKIE_KEY, MOBILE_BREAKPOINT, DEFAULT_MAIN_LINK_KEYS, SIGN_IN_URL, SIGN_UP_URL } from './constants/constants.js';
import useIsMobile from '../../utils/useIsMobile/useIsMobile.js';
import MobileNav from './MobileNav/MobileNav.js';
import MainNav from './MainNav/MainNav.js';
function GlobalNavContent({
  subNavLinks,
  mainCTA,
  secondaryCTA,
  visibleSections = DEFAULT_MAIN_LINK_KEYS,
  banner,
  maxWidth,
  isInUboExperimentTreatment,
  isInRewardsHubExperiment,
  hideNavLinks,
  customLogoUrl,
  localeInformation,
  userLocaleInfo,
  disableStickyness
}) {
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  const _useCookie = useCookie(COUNTRY_BANNER_COOKIE_KEY),
    _useCookie2 = _slicedToArray(_useCookie, 1),
    isCountryBannerDismissed = _useCookie2[0];
  const isMobile = useIsMobile(MOBILE_BREAKPOINT);
  const NavComponent = isMobile ? MobileNav : MainNav;
  const _useContext = useContext(GlobalNavContext),
    isUKUser = _useContext.isUKUser;
  const mainLinks = isUKUser ? MAIN_LINKS_UK : MAIN_LINKS;
  const navLinks = hideNavLinks ? [] : mainLinks.filter(item => {
    // If visible sections is an empty array, show all default sections
    if (visibleSections.length === 0) return true;
    if (visibleSections.includes(item.key)) return true;

    // Hide learn section for UK users due to UK FinProm Regulations
    if (item.key === 'learn' && !isUKUser) {
      return true;
    }
    return false;
  });
  return /*#__PURE__*/jsx(NavComponent, {
    navLinks: navLinks,
    activeTab: activeTab,
    setSelectedTab: setActiveTab,
    subNavLinks: subNavLinks,
    mainCTA: mainCTA,
    secondaryCTA: secondaryCTA,
    banner: banner,
    maxWidth: maxWidth,
    isInUboExperimentTreatment: isInUboExperimentTreatment,
    isInRewardsHubExperiment: isInRewardsHubExperiment,
    customLogoUrl: customLogoUrl,
    localeInformation: localeInformation,
    userLocaleInfo: userLocaleInfo ?? {},
    isCountryBannerDismissed: isCountryBannerDismissed,
    disableStickyness: disableStickyness
  });
}
function GlobalNav({
  initIsMobile,
  themeMode = 'default',
  subNavLinks,
  messages,
  mainCTA,
  secondaryCTA,
  locale = 'en',
  visibleSections,
  showGetStartedButtonOnMobile = true,
  useRelativeLinks,
  signInUrl = SIGN_IN_URL,
  signUpUrl = SIGN_UP_URL,
  onClickSignIn,
  onClickSignUp,
  productName = '',
  productUrl = '',
  onClickProductName,
  isJapan = false,
  isIndia = false,
  useNewLogo = false,
  isInUboExperimentTreatment = false,
  isInRewardsHubExperiment = false,
  showSignInButton = true,
  showSignUpButton = true,
  banner,
  maxWidth,
  showCoinbaseBytes,
  onUrlChange,
  coinbaseAccountsBaseUrl,
  hideNavLinks,
  customLogoUrl,
  localeInformation,
  userLocaleInfo,
  isGlobalPreferencesEnabled = false,
  isCountrySwitchBannerEnabled = false,
  subNavSecondaryLink,
  disableStickyness,
  detachBannerFromNav
}) {
  const theme = getTheme(themeMode);
  const _useState3 = useState(_objectSpread(_objectSpread({}, DEFAULT_GLOBAL_NAV_CONTEXT), {}, {
      themeMode,
      signInUrl,
      signUpUrl,
      onClickSignIn,
      onClickSignUp,
      productName,
      productUrl,
      onClickProductName,
      isJapan,
      isIndia,
      useNewLogo,
      showSignInButton,
      showSignUpButton,
      showGetStartedButtonOnMobile,
      showCoinbaseBytes,
      isUKUser: userLocaleInfo?.countryFromIp?.toUpperCase() === 'GB' || userLocaleInfo?.countryFromUrl?.toUpperCase() === 'GB' || false,
      localeCode: userLocaleInfo?.localeCode && userLocaleInfo?.localeCode !== 'en' ? userLocaleInfo?.localeCode : '',
      localeFromUrl: userLocaleInfo?.localeFromUrl || '',
      isGlobalPreferencesEnabled,
      isCountrySwitchBannerEnabled,
      subNavSecondaryLink,
      detachBannerFromNav
    })),
    _useState4 = _slicedToArray(_useState3, 1),
    globalNavContextValue = _useState4[0];
  return /*#__PURE__*/jsx(IntlProvider, {
    messages: messages,
    locale: locale,
    children: /*#__PURE__*/jsx(DefaultIsMobileContext.Provider, {
      value: !!initIsMobile,
      children: /*#__PURE__*/jsx(UrlContext.Provider, {
        value: {
          baseUrl: useRelativeLinks ? '' : DEFAULT_BASE_URL,
          onUrlChange,
          coinbaseAccountsBaseUrl: coinbaseAccountsBaseUrl || COINBASE_ACCOUNTS_DEFAULT_BASE_URL
        },
        children: /*#__PURE__*/jsx(GlobalNavContext.Provider, {
          value: globalNavContextValue,
          children: /*#__PURE__*/jsx(ThemeProvider, {
            theme: theme,
            children: /*#__PURE__*/jsx(Fragment, {
              children: /*#__PURE__*/jsx(GlobalNavContent, {
                subNavLinks: subNavLinks,
                visibleSections: visibleSections,
                mainCTA: mainCTA,
                secondaryCTA: secondaryCTA,
                banner: banner,
                maxWidth: maxWidth,
                isInUboExperimentTreatment: isInUboExperimentTreatment,
                isInRewardsHubExperiment: isInRewardsHubExperiment,
                hideNavLinks: hideNavLinks,
                customLogoUrl: customLogoUrl,
                localeInformation: localeInformation,
                userLocaleInfo: userLocaleInfo,
                disableStickyness: disableStickyness
              })
            })
          })
        })
      })
    })
  });
}
const GlobalNav$1 = /*#__PURE__*/memo(GlobalNav);
export { GlobalNav$1 as default };
//# sourceMappingURL=GlobalNav.js.map
